import type { SelectOption } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import {
  INQUIRY_RECRUITMENT_TYPE_COLOR_MAP,
  INQUIRY_RECRUITMENT_TYPE_LABEL_MAP,
  INQUIRY_RECRUITMENT_TYPE_UNSET_LABEL,
  type InquiryRecruitmentType,
  RECRUITMENT_TYPE_VALUES,
} from 'shared'

/**
 * 募集形態の選択肢
 * 一度入れた値を未設定（null）に戻せるよう、値が空文字の「未設定」を末尾に置く。未設定は色を付けず文字だけで表示する
 */
export const recruitmentTypeOptions: SelectOption[] = [
  ...RECRUITMENT_TYPE_VALUES.map((value) => ({
    value,
    label: INQUIRY_RECRUITMENT_TYPE_LABEL_MAP[value],
    color: INQUIRY_RECRUITMENT_TYPE_COLOR_MAP[value],
  })),
  { value: '', label: INQUIRY_RECRUITMENT_TYPE_UNSET_LABEL },
]

/**
 * AppSelectPopover から受け取った文字列を、フォームの値（未設定は空文字）に変換する
 * onSelect は string で値を返すため、型を絞り込んでから扱う。定義外の値は未設定として扱う
 */
export function toRecruitmentTypeFormValue(value: string): InquiryRecruitmentType | '' {
  return RECRUITMENT_TYPE_VALUES.find((recruitmentType) => recruitmentType === value) ?? ''
}
